module.exports = __webpack_public_path__ + "static/img/11.12fb6fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/11.png
// module id = onRv
// module chunks = 1